import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function AdditionalServices() {
  const {
    t
  } = useLanguage();
  const services = [t('services.s1'), t('services.s2'), t('services.s3'), t('services.s4')];
  return <section className="py-24 bg-[#F5EDE0] relative overflow-hidden" data-id="element-31">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-33">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-34">
            <div data-id="element-35">
              <h2 className="text-3xl md:text-4xl font-serif text-zinc-900 mb-4" data-id="element-36">
                {t('services.title.part1')}{' '}
                <span className="text-[#D4A843] italic" data-id="element-37">
                  {t('services.title.part2')}
                </span>
              </h2>
              <div className="w-16 h-[1px] bg-[#D4A843] mb-6" data-id="element-38"></div>
              <p className="text-zinc-700 text-lg font-light leading-relaxed" data-id="element-39">
                {t('services.desc')}
              </p>
            </div>

            <ul className="space-y-4" data-id="element-40">
              {services.map((service, index) => <motion.li key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1 + 0.3
            }} className="flex items-center gap-4 text-zinc-700 font-light" data-id="element-41">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-[#0D9488]/10 flex items-center justify-center" data-id="element-42">
                    <Check className="w-4 h-4 text-[#0D9488]" data-id="element-43" />
                  </div>
                  {service}
                </motion.li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-44">
            <div className="absolute inset-0 bg-[#D4A843]/5 translate-x-4 translate-y-4 border border-[#D4A843]/20 z-0" data-id="element-45"></div>
            <img src="https://cdn.magicpatterns.com/uploads/ndUzpfLV7yg53Rp25fn5VQ/lisaaa.jpg" alt="Signature Cocktail Close-up" className="w-full h-auto object-cover relative z-10 shadow-xl" data-id="element-46" />
          </motion.div>
        </div>
      </div>
    </section>;
}